/**
 * <strong>Purpose:</strong> <br>
 * This mixin places the button's buttonNode before the button's focusNode so as to allow for
 * splitting of actions and dropdown behavior, and sets up and
 * manages listeners on the widget's buttonNode to help manage focus related events.
 *
 * <strong>Contract:</strong> <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/MenuMixin}<br>
 *
 * @module mw-form/mixins/property/SplitButtonToggleSplitButtonMenuMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "dojo/_base/lang",
        "dojo/dom",
        "dojo/dom-construct",
        "dojo/on",

        "mw-dom-utils/domUtils",
        "mw-utils/widgetUtils",
        "mw-form/mixins/property/MenuMixin"
    ],
    function (declare, lang, dom, domConstruct, on, domUtils, widgetUtils, MenuMixin) {
        var SplitButtonToggleSplitButtonMenuMixin = declare(null, {

            buildRendering: function () {
                this.inherited(arguments);
                domConstruct.place(this.buttonNode, this.focusNode, "before");
            },

            _onMouseClick: function (/*Event*/ e) {
                this.inherited(arguments);

                // g1297387 - Clicking on the button node should close the menu
                if (dom.isDescendant(e.target, this.buttonNode) && this.isMenuOpen()) {
                    this.closeMenu(false);
                }
            }

        });

        SplitButtonToggleSplitButtonMenuMixin._dependencies = [
            {mixin: MenuMixin, orderDependent: true}
        ];

        return SplitButtonToggleSplitButtonMenuMixin;
    });